import { Component } from "react"
import PropTypes from "prop-types"
import { List, ListItemButton, ListItemText, Divider } from "@mui/material"
import withNavigate from "hocs/withNavigate"

class ExperimentsList extends Component {
  static propTypes = {
    researchTopicId: PropTypes.string.isRequired,
    account: PropTypes.string.isRequired,
    navigate: PropTypes.func.isRequired,
    close: PropTypes.func,
    openSearch: PropTypes.func.isRequired,
    trackExperimentTypeSelection: PropTypes.func.isRequired,
    toggleSaveExperiment: PropTypes.func.isRequired,
    openCreateInstrumentHedge: PropTypes.func.isRequired,
    isInstrumentPortfolio: PropTypes.bool.isRequired,
  }

  openCreateSmartTrade = () => {
    const { navigate, account, researchTopicId, trackExperimentTypeSelection, close } = this.props
    close()
    trackExperimentTypeSelection("smartTrade")
    navigate(`/${account}/t/${researchTopicId}/smart-trade/create/setup`)
  }

  openSearch = () => {
    const { openSearch, trackExperimentTypeSelection } = this.props
    openSearch()
    trackExperimentTypeSelection("search")
  }

  toggleSaveExperiment = () => {
    const { toggleSaveExperiment, trackExperimentTypeSelection } = this.props
    trackExperimentTypeSelection("upload")
    toggleSaveExperiment()
  }

  render() {
    const { openCreateInstrumentHedge, isInstrumentPortfolio } = this.props

    const smartTradeType = isInstrumentPortfolio ? "portfolio" : "trade"
    const instrumentType = isInstrumentPortfolio ? "portfolio" : "security"

    return <List className="research-topic-experiments-list">
      <Divider component="li" />
      <ListItemButton id="research-topic-add-smart-trade" onClick={this.openCreateSmartTrade}>
        <ListItemText primary={`Smart ${smartTradeType}`} secondary={`Create a hedge basket to neutralize a ${instrumentType}'s factor risk`} />
      </ListItemButton>
      <Divider component="li" />
      <ListItemButton id="research-topic-add-hedge-instrument" onClick={openCreateInstrumentHedge}>
        <ListItemText primary="Index, ETF, or single security hedge" secondary="Manually select an index, ETF, or security to use as a hedge instrument" />
      </ListItemButton>
      <Divider component="li" />
      <ListItemButton id="research-topic-add-existing" onClick={this.openSearch}>
        <ListItemText primary="Search for an existing alternative" secondary="Browse through saved or previously uploaded alternatives" />
      </ListItemButton>
      <Divider component="li" />
      <ListItemButton id="research-topic-add-upload" onClick={this.toggleSaveExperiment}>
        <ListItemText primary="Upload alternative experiment" secondary="Select .csv, .xlsx file that correspond to an experiment" />
      </ListItemButton>
    </List>
  }
}

export default withNavigate(ExperimentsList)
